import React from 'react';

import '../css/AboutMe.css';
import { aboutMe } from '../EditMe';

function AboutMe() {
    return (
        <div className="aboutme-container">
            <div className="main">
            I’m a fullstack web developer based in Nabeul, Tunisia. I was working as an electrical engineer and then i decided to change domain
            to web development which is an interesting and enjoyable field.
            I've been building applications on the web for the last two years.
            My focus is on creating accessible & performant interfaces for humans.
            </div>
        </div>
    );
}

export default AboutMe;